export type UnityCameraPoint = {
  position: [number, number, number];
  rotation: [number, number, number];
  distance: number;
  duration: number;
};

export type UnityCameraData = {
  cameraPoints: UnityCameraPoint[];
};

const DEFAULT_UNITY_CAMERA_POINT: UnityCameraPoint = {
  // rotation 调整视觉角度，distance 调整相机高度/远近。
  position: [762, 0, 913],
  rotation: [49.404, 179.636, 0],
  distance: 1489,
  duration: 0.8,
};

const createUnityCameraData = (point: UnityCameraPoint = DEFAULT_UNITY_CAMERA_POINT): UnityCameraData[] => [
  {
    cameraPoints: [point],
  },
];

export const DEFAULT_UNITY_INITIAL_CAMERA_DATA = createUnityCameraData();

export const UNITY_CAMERA_CONFIG: Record<
  'power' | 'unityPower' | 'light' | 'water' | 'energyCockpit' | 'environment' | 'gas',
  UnityCameraData[]
> = {
  power: createUnityCameraData({
    position: [1279.452, 0, 533.3959],
    rotation: [27.40993, 235.9964, 0.0000009617431],
    distance: 2239.006,
    duration: 0.8,
  }),
  unityPower: createUnityCameraData({
    position: [1279.452, 0, 533.3959],
    rotation: [27.40993, 235.9964, 0.0000009617431],
    distance: 2239.006,
    duration: 0.8,
  }),
  light: createUnityCameraData({
    position: [1014.009, 0, 784.5934],
    rotation: [35.69719, 199.0864, 0],
    distance: 1900.007,
    duration: 0.8,
  }),
  water: createUnityCameraData({
    position: [545.4843, 0, 773.1262],
    rotation: [31.64921, 159.6912, 0],
    distance: 2089.005,
    duration: 0.8,
  }),
  energyCockpit: createUnityCameraData({
    position: [580.9587, 0, 963.7538],
    rotation: [37.18523, 167.9159, 0],
    distance: 1789,
    duration: 0.8,
  }),
  environment: createUnityCameraData({
    position: [622.7241, 0, 867.3079],
    rotation: [46.5983, 177.8745, -0.0000001553199],
    distance: 2242.367,
    duration: 0.8,
  }),
  gas: createUnityCameraData({
    position: [1160.087, 0, 794.4955],
    rotation: [35.68907, 217.2898, 0.000001051193],
    distance: 1950.003,
    duration: 0.8,
  }),
};
